import { useMemo } from 'react'

type NameBlockProps = {
  firstName: string
  lastName: string
}

const NameBlock = ({ firstName, lastName }: NameBlockProps) => {
  const initials = useMemo(() => [firstName[0], lastName[0]].filter(Boolean).join(' '), [firstName, lastName])

  return (
    <div className="-mb-10 inline-flex items-center gap-4">
      <div className="inline-flex items-center justify-center w-14 h-14 rounded-full bg-primary-800 typography-body-xl text-white text-center -tracking-widest">
        {initials}
      </div>
      <p className="typography-body-xxl text-primary-800">
        {firstName} {lastName}
      </p>
    </div>
  )
}

export default NameBlock
